import { administrationRequests } from "api/administrationApi";
import React from "react";
import { ReferenceArrayInput, required, SelectArrayInput } from "react-admin";

const CitizenshipInput = ({ isArray, selectedIds, handleChange, readOnly, isBgAndForeignersSeperated }) => {
  return isArray ? (
    <ReferenceArrayInput
      source="citizenship"
      reference={administrationRequests.getCitizenshipSelect()}
      filter={{ selectedIds: selectedIds, isBgAndForeignersSeperated: isBgAndForeignersSeperated ? true : false }}
    >
      <SelectArrayInput
        label="Гражданство"
        validate={[required()]}
        onChange={handleChange}
        readOnly={readOnly}
      />
    </ReferenceArrayInput>
  ) : null;
};

export default CitizenshipInput;
